// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsComparisonSpecificsComparatesFromJSON, DatapointsComparisonSpecificsComparatesToJSON, } from './';
export function DatapointsComparisonSpecificsFromJSON(json) {
    return {
        'entityAlias': json['entityAlias'],
        'comparates': json['comparates'].map(DatapointsComparisonSpecificsComparatesFromJSON),
    };
}
export function DatapointsComparisonSpecificsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'entityAlias': value.entityAlias,
        'comparates': value.comparates.map(DatapointsComparisonSpecificsComparatesToJSON),
    };
}
